<template>
  <div>
    <el-dialog
      append-to-body
      v-dialogDrag
      :title="`${$t('关联自评记录')}`"
      class="mid-dialog"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <div class="flex flex-wrap">
        <el-input
          clearable
          v-model="search.name"
          class="w-200px mr-10px mb-10px"
          size="small"
          :maxlength="50"
          :placeholder="`${$t('评价名称')}`"
        ></el-input>
        <select-tree
          v-model="search.organizationId"
          :optionList="departmentList"
          :treeProps="{
            label: 'displayName',
            children: 'children',
          }"
          :placeholder="`${$t('评价单位')}`"
          class="w-200px mr-10px"
        />
        <el-button @click="searchList" size="small" type="primary">{{ $t('搜索') }}</el-button>
        <el-button @click="reset" size="small">{{ $t('重置') }}</el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        height="calc(100% - 104px)"
        class="mt-10px"
        ref="table"
        row-key="id"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          reserve-selection
        ></el-table-column>
        <el-table-column width="60" :label="`${$t('序号')}`" type="index"></el-table-column>
        <el-table-column
          prop="name"
          show-overflow-tooltip
          :label="`${$t('评价名称')}`"
        ></el-table-column>
        <el-table-column
          prop="creator"
          show-overflow-tooltip
          :label="`${$t('评价人')}`"
        ></el-table-column>
        <el-table-column
          prop="organization"
          show-overflow-tooltip
          :label="`${$t('评价单位')}`"
        ></el-table-column>
        <el-table-column
          prop="beginTime"
          show-overflow-tooltip
          :label="`${$t('评价开始时间')}`"
        ></el-table-column>
        <el-table-column
          prop="totalStandardScore"
          show-overflow-tooltip
          :label="`${$t('评价标准总分')}`"
        ></el-table-column>
        <el-table-column
          prop="totalScore"
          show-overflow-tooltip
          :label="`${$t('自评得分')}`"
        ></el-table-column>
        <el-table-column
          prop="scorePercentage"
          show-overflow-tooltip
          :label="`${$t('得分占比')}`"
        ></el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px text-right"
        background
        :current-page.sync="page.pageNo"
        @size-change="searchList"
        @current-change="findList"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <div slot="footer" class="text-center">
        <el-button
          size="small"
          type="primary"
          class="iconfont icon-save"
          @click="save()"
          :loading="loading"
          >保存</el-button
        >
        <el-button size="small" class="iconfont icon-close" @click="closeDialog()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { SafetyEvaluationSolutionApi } from '@wiz-api/safety-evaluation-management'
import { OrganizationApi } from '@wiz-api/abp-identity'
import dayjs from 'dayjs'
import { forEach, find } from 'lodash'

const SelectTree = () => {
  return import('@/components/safety/FormSelect/SelectTree')
}
const organizationApi = new OrganizationApi()
const safetyEvaluationSolutionApi = new SafetyEvaluationSolutionApi()
export default {
  components: {
    SelectTree,
  },
  props: {
    source: {
      type: Number,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    selectedIds: {
      type: Array,
      default: () => {
        return []
      },
    },
    max: {
      type: Number,
      default: Infinity,
    },
  },
  data() {
    return {
      departmentList: [],
      search: {
        name: '',
        organizationId: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
      },
      total: 0,
      loading: false,
      tableData: [],
      selection: [],
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  watch: {
    async dialogVisible(val) {
      if (val) {
        await this.searchList()
        this.$nextTick(() => {
          forEach(this.selectedIds, (id) => {
            const item = find(this.tableData, { id })
            if (item) {
              this.$refs.table.toggleRowSelection(item, true)
            }
          })
        })
      }
    },
  },
  methods: {
    async findList() {
      this.loading = true
      const [err, res] = await safetyEvaluationSolutionApi.getByPage(this.source, {
        ...this.search,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        status: 2,
      })
      if (!err) {
        const statusMap = {
          0: '待发布',
          1: '自评中',
          2: '已自评',
        }
        this.tableData = res.items.map((item) => {
          return {
            ...item,
            statusName: statusMap[item.status],
            beginTime: dayjs(item.beginTime).format('YYYY-MM-DD'),
          }
        })
        this.total = res.totalCount
      }
      this.loading = false
    },
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    reset() {
      this.search = this.$options.data().search
      this.searchList()
    },
    async getOrgData() {
      const [err, res] = await organizationApi.getAllListDetails({})
      if (!err && res?.items.length) {
        this.departmentList = res?.items
        // this.departmentList = res?.items[0].children
      }
    },
    closeDialog(done) {
      this.selection = []
      this.search = this.$options.data().search
      this.page = this.$options.data().page
      this.total = 0
      this.$refs.table.clearSelection()
      if (done) {
        done()
      } else {
        this.dialogVisible = false
      }
    },
    handleSelectionChange(selection) {
      this.selection = selection
    },
    save() {
      if (this.selection.length === 0) {
        this.$message.warning('请选择自评记录')
        return
      }
      if (this.selection.length > this.max) {
        this.$message.warning(`最多只能选择${this.max}条记录`)
        return
      }
      const seen = new Set()
      let isRepeat = false
      this.selection.some((item) => {
        if (seen.has(item.organization)) {
          isRepeat = true
          return isRepeat
        }
        seen.add(item.organization)
        return isRepeat
      })
      if (isRepeat) {
        this.$message.warning('同一个评价单位只能选择一条记录')
        return
      }
      this.$emit('save', this.selection)
      this.dialogVisible = false
    },
  },
  created() {
    this.getOrgData()
  },
}
</script>

<style></style>
